import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { useId } from "react"

type Props = {
  onCheckedChange: (checked: boolean) => void
  checked: boolean
  label: string
  name?: string
  required?: boolean
  disabled?: boolean
  file_url?: string
}

export function Checkbox(props: Props) {
  const id = useId()

  return (
    <>
      {props.file_url ? (
        <div className="flex items-center gap-4 py-2 w-[calc((100%-(var(--spacing-4)*1))*(1/2))] md:w-[calc((100%-(var(--spacing-4)*2))*(1/3))]">
          <input
            type="checkbox"
            aria-label={props.label}
            id={id}
            name={props.name}
            required={props.required}
            disabled={props.disabled}
            checked={props.checked}
            onChange={(e) => {
              props.onCheckedChange(e.currentTarget.checked)
            }}
            className="hidden [&:checked+label>div>div>div]:flex"
          />

          <label
            htmlFor={id}
            className="type-label-m text-text cursor-pointer flex items-center gap-4 flex-col w-full p-5 bg-bgAlt rounded-md"
          >
            <ResponsiveImage mediaItemUrl={props.file_url} aspect={1} className="rounded-sm overflow-hidden w-full" />
            <div className="flex w-full gap-4">
              <div className="w-5 h-5 flex items-center justify-center border">
                <div className="w-3 h-3 hidden bg-text" />
              </div>
              <span dangerouslySetInnerHTML={{ __html: props.label }} />
            </div>
          </label>
        </div>
      ) : (
        <div className="flex items-center gap-4 py-2">
          <input
            type="checkbox"
            aria-label={props.label}
            id={id}
            name={props.name}
            required={props.required}
            disabled={props.disabled}
            checked={props.checked}
            onChange={(e) => {
              props.onCheckedChange(e.currentTarget.checked)
            }}
            className="hidden [&:checked+label>div>div]:flex"
          />

          <label htmlFor={id} className="type-label-m text-text cursor-pointer flex items-center gap-4 py-2">
            <div className="w-5 h-5 flex items-center justify-center border">
              <div className="w-3 h-3 hidden bg-text" />
            </div>
            <span dangerouslySetInnerHTML={{ __html: props.label }} />
          </label>
        </div>
      )}
    </>
  )
}
